module.exports = __webpack_public_path__ + "static/media/ios-book.996d8c7d.svg";